/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { string, bool } from "prop-types";
import { connect, useSelector } from "react-redux";
import { parseUrl } from "query-string";
import get from "lodash/get";
import { withFacebookLogin, withGoogleLogin } from "@quintype/bridgekeeper-js";

import { Button } from "../../atoms";
import { SvgIconHandler } from "../../atoms/SvgIconHandler";

import "./social-login.m.css";

export const SocialLoginBase = ({ customCallbackUrl, magazine = false }) => {
  const publisherAttributes = useSelector((state) => get(state, ["qt", "config", "publisher-attributes"], {}));
  const currentPath = useSelector((state) => get(state, ["qt", "currentPath"], ""));
  const ssoLoginIsEnable = get(publisherAttributes, ["sso_login", "is_enable"], false);
  const fbLoginEnable = get(publisherAttributes, ["sso_login", "fbLoginEnable"], false);
  const clientId = get(publisherAttributes, ["sso_login", "client_id"], "");

  const [googleLoginPath, setGoogleLoginPath] = useState("");
  const [facebookLoginPath, setFacebookLoginPath] = useState("");

  useEffect(() => {
    const params = parseUrl(currentPath);
    const urlParam = get(params, ["query", "url"]);
    const callbackUrl =
      urlParam !== undefined && urlParam !== null
        ? urlParam
        : customCallbackUrl ||
          get(params, ["query", "callback_uri"]) ||
          get(publisherAttributes, ["sso_login", "callback_Url"], "");
    const callbackUrlWithToast = `${callbackUrl}?toastMessage=You have successfully Signed In!`;
    const getRedirectUrl = get(publisherAttributes, ["sso_login", "redirect_Url"], "");
    const location = new URL(window.location.href);
    const oauthAuthorize = `${location.origin}/api/auth/v1/oauth/authorize?redirect_uri=${getRedirectUrl}&client_id=${clientId}&callback_uri=${callbackUrlWithToast}&response_type=code`;
    const redirectUrl = ssoLoginIsEnable ? oauthAuthorize : `${location.origin}${location.pathname}`;

    const { serverSideLoginPath: googlePath } = withGoogleLogin({
      scope: "email",
      emailMandatory: true,
      redirectUrl: encodeURIComponent(redirectUrl),
    });
    setGoogleLoginPath(googlePath);
    const { serverSideLoginPath: facebookPath } = withFacebookLogin({
      scope: "email",
      emailMandatory: true,
      redirectUrl: encodeURIComponent(redirectUrl),
    });
    setFacebookLoginPath(facebookPath);
  }, []);

  const handleClick = (clickText) => {
    if (typeof window !== "undefined" && window.dataLayer) {
      window.dataLayer.push({
        event: "dl_login_steps",
        event_action: clickText,
      });
    }
  };

  const GoogleLogin = () => {
    return (
      <Button
        color="#dd4b39"
        flat
        href={googleLoginPath}
        socialButton
        onClickFunction={() => handleClick("google click")}
      >
        <span styleName={`icon ${magazine ? "magazine-login-icon" : ""}`}>
          <SvgIconHandler type="google" width="18" height="18" viewBox="0 0 13 13" />
        </span>{" "}
        {magazine ? "" : "Google"}
      </Button>
    );
  };

  const FaceBookLogin = () => {
    return (
      <Button
        color="#3b5998"
        flat
        href={facebookLoginPath}
        socialButton
        onClickFunction={() => handleClick("facebook click")}
      >
        <span styleName={`icon ${magazine ? "magazine-login-icon" : ""}`}>
          <SvgIconHandler type="facebook" iconStyle={{ color: "#3b5998" }} width="18" height="18" viewBox="0 0 12 21" />
        </span>
        {magazine ? "" : "Facebook"}
      </Button>
    );
  };

  return (
    <div styleName="social-login">
      <ul styleName="buttons">
        <li styleName="button">
          <GoogleLogin />
        </li>
        {fbLoginEnable ? (
          <li styleName="button">
            <FaceBookLogin />
          </li>
        ) : null}
      </ul>
    </div>
  );
};

SocialLoginBase.propTypes = {
  googleAppId: string,
  facebookAppId: string,
  customCallbackUrl: string,
  magazine: bool,
};

const mapStateToProps = (state) => ({
  googleAppId: get(state, ["qt", "config", "publisher-attributes", "google_app_id"], ""),
  facebookAppId: get(state, ["qt", "config", "publisher-attributes", "facebook_app_id"], ""),
});

export const SocialLogin = connect(mapStateToProps, null)(SocialLoginBase);
